export interface AeropuertoData {
  iata: string;
  nombre: string;
  ciudad: string;
  provincia: string;
  websiteUrl: string;
  imagen: string;
}

export const aeropuertosRD: AeropuertoData[] = [
  {
    iata: "SDQ",
    nombre: "Aeropuerto Internacional de Las Américas",
    ciudad: "Santo Domingo",
    provincia: "Distrito Nacional",
    websiteUrl: "https://aeropuertolasamericas.com/",
    imagen:
      "https://readdy.ai/api/search-image?query=Las%20Americas%20International%20Airport%20SDQ%20in%20Santo%20Domingo%20Dominican%20Republic%2C%20modern%20international%20airport%20terminal%20with%20aircraft%2C%20Caribbean%20architecture%2C%20professional%20travel%20magazine%20cover%2C%20realistic%20editorial%20photography&width=800&height=500&seq=airport-sdq-cover&orientation=landscape",
  },
  {
    iata: "PUJ",
    nombre: "Aeropuerto Internacional de Punta Cana",
    ciudad: "Punta Cana",
    provincia: "La Altagracia",
    websiteUrl: "https://www.puntacanainternationalairport.com/es/",
    imagen:
      "https://readdy.ai/api/search-image?query=Luxury%20cover%20image%20of%20Punta%20Cana%20International%20Airport%20%28PUJ%29%2C%20tropical%20architecture%20with%20palm-style%20roofs%2C%20aerial%20airport%20runway%20view%2C%20Caribbean%20sunlight%2C%20luxury%20tourism%20aesthetic%2C%20realistic%20editorial%20photography&width=800&height=500&seq=airport-puj-cover&orientation=landscape",
  },
  {
    iata: "POP",
    nombre: "Aeropuerto Internacional Gregorio Luperón",
    ciudad: "Puerto Plata",
    provincia: "Puerto Plata",
    websiteUrl: "https://aeropuertopuertoplata.com/",
    imagen:
      "https://readdy.ai/api/search-image?query=Aeropuerto%20Internacional%20Gregorio%20Luperon%20%28POP%29%20en%20Puerto%20Plata%2C%20Republica%20Dominicana%2C%20terminal%20moderna%20cerca%20del%20mar%2C%20montanas%20tropicales%20al%20fondo%2C%20estilo%20portada%20de%20revista%20de%20viajes%2C%20ultra%20realistic&width=800&height=500&seq=airport-pop-cover&orientation=landscape",
  },
  {
    iata: "STI",
    nombre: "Aeropuerto Internacional del Cibao",
    ciudad: "Santiago",
    provincia: "Santiago",
    websiteUrl: "https://aeropuertocibao.com.do/",
    imagen:
      "https://readdy.ai/api/search-image?query=Cibao%20International%20Airport%20%28STI%29%20in%20Santiago%20Dominican%20Republic%2C%20airport%20terminal%20with%20airplanes%20on%20runway%2C%20modern%20Caribbean%20airport%2C%20clean%20architecture%2C%20editorial%20travel%20cover%20style&width=800&height=500&seq=airport-sti-cover&orientation=landscape",
  },
  {
    iata: "LRM",
    nombre: "Aeropuerto Internacional La Romana",
    ciudad: "La Romana",
    provincia: "La Romana",
    websiteUrl: "https://www.romanaairport.com/",
    imagen:
      "https://readdy.ai/api/search-image?query=La%20Romana%20International%20Airport%20%28LRM%29%2C%20elegant%20tropical%20airport%20in%20Dominican%20Republic%2C%20private%20jet%20atmosphere%2C%20luxury%20Caribbean%20destination%2C%20sunset%20lighting%2C%20realistic%20travel%20magazine%20cover&width=800&height=500&seq=airport-lrm-cover&orientation=landscape",
  },
  {
    iata: "AZS",
    nombre: "Aeropuerto Internacional El Catey",
    ciudad: "Samaná",
    provincia: "Samaná",
    websiteUrl: "https://aeropuertosamana.com/",
    imagen:
      "https://readdy.ai/api/search-image?query=El%20Catey%20Samana%20Airport%20%28AZS%29%2C%20tropical%20airport%20surrounded%20by%20lush%20green%20mountains%20and%20Caribbean%20nature%2C%20cinematic%20aerial%20view%2C%20luxury%20tourism%20branding%20style&width=800&height=500&seq=airport-azs-cover&orientation=landscape",
  },
  {
    iata: "BRX",
    nombre: "Aeropuerto Internacional María Montez",
    ciudad: "Barahona",
    provincia: "Barahona",
    websiteUrl: "https://aeropuertobarahona.com/",
    imagen:
      "https://readdy.ai/api/search-image?query=Maria%20Montez%20Airport%20%28BRX%29%20in%20Barahona%20Dominican%20Republic%2C%20small%20tropical%20regional%20airport%20with%20dramatic%20mountains%20and%20ocean%20nearby%2C%20cinematic%20realistic%20photography&width=800&height=500&seq=airport-brx-cover&orientation=landscape",
  },
  {
    iata: "JBQ",
    nombre: "Aeropuerto Internacional Dr. Joaquín Balaguer",
    ciudad: "Santo Domingo",
    provincia: "Distrito Nacional",
    websiteUrl: "https://aeropuertolaisabela.com/",
    imagen:
      "https://readdy.ai/api/search-image?query=La%20Isabela%20Joaquin%20Balaguer%20Airport%20%28JBQ%29%2C%20domestic%20airport%20in%20Santo%20Domingo%2C%20modern%20terminal%20with%20Dominican%20urban%20atmosphere%2C%20professional%20travel%20publication%20cover%2C%20realistic%20style&width=800&height=500&seq=airport-jbq-cover&orientation=landscape",
  },
];